import axios from "axios";

export enum SubscriptionTierType {
  STARTER_BASE = "STARTER_BASE",
  FULL_SUITE = "FULL_SUITE",
}
export interface SubscriptionTierDTO {
  id: string;
  displayName: string;
  type: SubscriptionTierType;
}

export async function getSubscriptionTiers() {
  const baseApiUrl = process.env.REACT_APP_BASE_API_URL;

  return await axios.get(
    `${baseApiUrl}/payment/v0/community/subscription-tier`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      },
    },
  );
}
